<template>
  <div class="card">
    <NuxtLink :to="navTo">
      <div class="card--image">
        <img
          :src="`https://public-assets.naamdeo.org/cdn-cgi/image/fit=scale-down,width=960,quality=75/images/blog/${image}`"
          alt="post-image"
        />
      </div>
      <div class="card--content">
        <h1 class="card--content--title mt-2 text-lg capitalize">
          {{ title }}
        </h1>
        <p class="card--content--description mt-3 text-sm">{{ description }}</p>
        <button class="link-primary t-sm mt-4">Learn More</button>
      </div>
    </NuxtLink>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Card',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    navTo: {
      type: String,
      default: '',
    },
  },
});
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  background-color: #f1f5f5;
  border-bottom: 4px solid $dark;
  cursor: pointer;
  &--image {
    position: relative;
    width: 100%;
    aspect-ratio: 16/9;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &--content {
    padding: 8px 24px 24px;
    position: relative;
    cursor: pointer;
    &--date {
      position: relative;
      padding-left: 12px;
      color: $color-1;
      &:before {
        position: absolute;
        left: 0;
        content: '•';
        font-size: 15px;
        line-height: 16px;
      }
    }
    &--title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    &--description {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    &--divider {
      margin: 16px 0;
      height: 1px;
      background-color: #44444c;
      opacity: 0.4;
      width: 20%;
    }
  }

  &:hover {
    box-shadow: 1px 8px 40px 0px rgba(0, 0, 0, 0.2);
    transition: all 1s cubic-bezier(0.18, 0.32, 0.17, 0.99);
  }
}
</style>
